module.exports = __webpack_public_path__ + "img/Peti.4c6dce94.jpg";